module.exports = __webpack_public_path__ + "static/Rx.Health-a6d08fcd6a075f1ef0d2107ce29eeba3.jpg";